import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Container, Divider,
    List,
    ListItem,
    styled,
    Typography
} from "@mui/material";
import {KeyboardArrowDownRounded} from "@mui/icons-material";
import useThemeStore from "../../store/theme";

const QuestionAnswers = () => {

    const themeMode = useThemeStore(state => state.mode);
    const listStyles = {
        "& .MuiListItem-root:not(:first-of-type, :last-of-type) .MuiPaper-root": {
            borderRadius: 0
        },
        "& .MuiListItem-root:first-of-type .MuiPaper-root": {
            borderRadius: "4px 4px 0 0",
        },
        "& .MuiListItem-root:last-of-type .MuiPaper-root": {
            borderRadius: "0 0 4px 4px",
        },
    }

    return (
        <Container sx={{ mt: 10 }}>
            <Typography mb={2.5} variant="h6">سوالات متداول</Typography>
            <List sx={listStyles}>
                <ListItem disablePadding>
                    <StyledAccordion>
                        <AccordionSummary expandIcon={<KeyboardArrowDownRounded/>}>
                            <Typography fontWeight={500}>چجوری فایل آپلود کنیم؟</Typography>
                        </AccordionSummary>
                        <AccordionDetails>برای آپلود فایل وارد پنل کاربری می شوید بالا سمت چپ روی دکمه آپلود بزنید یک صفحه ای باز میشه داخل صفحه فیلد های خواسته شده رو پر می کنید و دکمه ثبت رو می زنید، صبر می‌کنید تا فایل مورد نظر آپلود بشه.</AccordionDetails>
                    </StyledAccordion>
                </ListItem>
                <Divider sx={themeMode === 'dark' && {borderColor: "#808080"} }/>
                <ListItem disablePadding>
                    <StyledAccordion>
                        <AccordionSummary expandIcon={<KeyboardArrowDownRounded/>}>
                            <Typography fontWeight={500}>نحوه ذخیره فایل در درایو شخصی؟</Typography>
                        </AccordionSummary>
                        <AccordionDetails>برای آپلود فایل وارد پنل کاربری می شوید بالا سمت چپ روی دکمه آپلود بزنید یک صفحه ای باز میشه داخل صفحه فیلد های خواسته شده رو پر می کنید و دکمه ثبت رو می زنید، صبر می‌کنید تا فایل مورد نظر آپلود بشه.</AccordionDetails>
                    </StyledAccordion>
                </ListItem>
                <Divider sx={themeMode === 'dark' && {borderColor: "#808080"} }/>
                <ListItem disablePadding>
                    <StyledAccordion>
                        <AccordionSummary expandIcon={<KeyboardArrowDownRounded/>}>
                            <Typography fontWeight={500}>از کجا میتونم فایل هایی که دانلود کردم رو ببینم؟</Typography>
                        </AccordionSummary>
                        <AccordionDetails>برای آپلود فایل وارد پنل کاربری می شوید بالا سمت چپ روی دکمه آپلود بزنید یک صفحه ای باز میشه داخل صفحه فیلد های خواسته شده رو پر می کنید و دکمه ثبت رو می زنید، صبر می‌کنید تا فایل مورد نظر آپلود بشه.</AccordionDetails>
                    </StyledAccordion>
                </ListItem>
                <Divider sx={themeMode === 'dark' && {borderColor: "#808080"} }/>
                <ListItem disablePadding>
                    <StyledAccordion>
                        <AccordionSummary expandIcon={<KeyboardArrowDownRounded/>}>
                            <Typography fontWeight={500}>نحوه آپلود فایل خصوصی؟</Typography>
                        </AccordionSummary>
                        <AccordionDetails>برای آپلود فایل وارد پنل کاربری می شوید بالا سمت چپ روی دکمه آپلود بزنید یک صفحه ای باز میشه داخل صفحه فیلد های خواسته شده رو پر می کنید و دکمه ثبت رو می زنید، صبر می‌کنید تا فایل مورد نظر آپلود بشه.</AccordionDetails>
                    </StyledAccordion>
                </ListItem>
                <Divider sx={themeMode === 'dark' && {borderColor: "#808080"} }/>
                <ListItem disablePadding>
                    <StyledAccordion>
                        <AccordionSummary expandIcon={<KeyboardArrowDownRounded/>}>
                            <Typography fontWeight={500}>چجوری فایل آپلود کنیم؟</Typography>
                        </AccordionSummary>
                        <AccordionDetails>برای آپلود فایل وارد پنل کاربری می شوید بالا سمت چپ روی دکمه آپلود بزنید یک صفحه ای باز میشه داخل صفحه فیلد های خواسته شده رو پر می کنید و دکمه ثبت رو می زنید، صبر می‌کنید تا فایل مورد نظر آپلود بشه.</AccordionDetails>
                    </StyledAccordion>
                </ListItem>
            </List>
        </Container>
    )
}
export default QuestionAnswers;

const StyledAccordion = styled(Accordion)(({theme}) => ({
    padding: "8px 0",
    backgroundColor: theme.palette.grey.main,
}));
StyledAccordion.defaultProps = {
    elevation: 0
}